// ABOUTME: Route for /loss-register — daily production targets, downtime, and separate rejects.
// ABOUTME: Line and date range live in the search params so a view can be linked.
import { LossRegisterPage } from "@/components/loss-register/LossRegisterPage";
import { createFileRoute } from "@tanstack/react-router";

export interface LossRegisterSearchParams {
  lineId?: string;
  start?: string;
  end?: string;
}

function optionalString(value: unknown): string | undefined {
  return typeof value === "string" && value ? value : undefined;
}

export const Route = createFileRoute("/_authenticated/loss-register")({
  validateSearch: (
    search: Record<string, unknown>,
  ): LossRegisterSearchParams => ({
    lineId: optionalString(search.lineId),
    start: optionalString(search.start),
    end: optionalString(search.end),
  }),
  component: LossRegisterPage,
});
